import router from 'src/router';
import {
  BASE_ROUTE,
  FLOW_ROUTE_WITHOUT_FLOW_ID,
  FLOW_ROUTE,
  NODE_ROUTE,
  FLOW_ROUTE_WITH_POST_VERIFICATION_FLOW_ID,
  NODE_ROUTE_WITH_POST_VERIFICATION_FLOW_ID
} from 'src/config/routes';
import baseHandler from 'src/router/routeControllers/baseHandler';
import postVerificationFlowIdHandler from 'src/router/routeControllers/postVerificationFlowIdHandler';

export default () => {
  router.addListener(BASE_ROUTE, baseHandler);
  router.addListener(FLOW_ROUTE_WITHOUT_FLOW_ID, baseHandler);
  router.addListener(FLOW_ROUTE, baseHandler);
  router.addListener(NODE_ROUTE, baseHandler);
  router.addListener(FLOW_ROUTE_WITH_POST_VERIFICATION_FLOW_ID, postVerificationFlowIdHandler);
  router.addListener(NODE_ROUTE_WITH_POST_VERIFICATION_FLOW_ID, postVerificationFlowIdHandler);
};
